import { useMemo } from 'react';
import { useCharacterStore, useWorldStore } from '@/engine/state';
import { resolverCondicionalesEnTexto } from '@/engine/narrative/conditionalText';
import type { ConditionContext } from '@/engine/narrative';

/**
 * Resuelve markup condicional `[if ...]...[/if]` en el texto dado,
 * reaccionando al estado del personaje y del mundo. Ideal para usarlo
 * justo antes de parsear markup visual.
 */
export function useTextoResuelto(texto: string): string {
  const personaje = useCharacterStore((s) => s.personaje);
  const flags = useWorldStore((s) => s.flags);
  const reputacion = useWorldStore((s) => s.reputacion);

  return useMemo(() => {
    const ctx: ConditionContext = {
      personaje: {
        stats: personaje.stats,
        skillsDesbloqueadas: personaje.skillsDesbloqueadas,
        hechizosAprendidos: personaje.hechizosAprendidos,
        inventario: personaje.inventario,
      },
      flags,
      reputacion,
    };
    return resolverCondicionalesEnTexto(texto, ctx);
  }, [texto, personaje, flags, reputacion]);
}
